import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CartContext } from "./CartContext";
import CategoryNavbar from "./CategoryNavbar";
import vyapakprintsLogo from "../assets/vyapakprints-logo.png";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSticky, setIsSticky] = useState(false);
  const { cartItems } = useContext(CartContext);
  const navigate = useNavigate();
  const navbarRef = useRef(null);

  const handleSearch = (e) => {
    e.preventDefault();
    const q = searchQuery.trim();
    if (q) {
      navigate(`/search?query=${encodeURIComponent(q)}`);
      setSearchQuery("");
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    }

    function handleScroll() {
      setIsSticky(window.scrollY > 80);
    }

    function handleEsc(e) {
      if (e.key === "Escape") setIsMenuOpen(false);
    }

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("keydown", handleEsc);
    };
  }, []);

  return (
    <header
      ref={navbarRef}
      className={`w-full z-50 ${
        isSticky ? "sticky top-0 bg-white shadow-md" : "bg-white"
      }`}
    >
      <nav className="text-mainpink border-b border-pink-100">
        {/* Top Bar */}
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-3">
          <div className="flex items-center justify-between gap-3">
            {/* Logo */}
            <Link to="/" className="flex items-center shrink-0">
              <img
                src={vyapakprintsLogo}
                className="w-32 sm:w-40 md:w-48"
                alt="Vyapakprints"
              />
            </Link>

            {/* Desktop search */}
            <div className="hidden md:block w-full max-w-xl">
              <form onSubmit={handleSearch} className="flex w-full">
                <input
                  type="text"
                  placeholder="Search products..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-4 py-2 rounded-l-md bg-pink-100 text-mainpink placeholder-pink-400 focus:outline-none focus:ring-2 focus:ring-pink-300 transition"
                  aria-label="Search products"
                />
                <button
                  type="submit"
                  className="px-4 py-2 bg-mainpink text-white rounded-r-md hover:bg-pink-700 transition flex items-center justify-center"
                  aria-label="Submit search"
                >
                  <i className="fa-solid fa-magnifying-glass" />
                </button>
              </form>
            </div>

            {/* Right Icons */}
            <div className="flex items-center gap-4 sm:gap-6">
              <Link
                to="/account"
                className="hover:text-pink-700 transition flex flex-col items-center"
              >
                <i className="fa-solid fa-user text-lg sm:text-xl" />
                <span className="text-[10px] sm:text-xs mt-1">Account</span>
              </Link>

              <Link
                to="/cart"
                className="hover:text-pink-700 transition flex flex-col items-center"
              >
                <span className="relative">
                  <i className="fa-solid fa-bag-shopping text-lg sm:text-xl" />
                  {cartItems.length > 0 && (
                    <span className="absolute -top-2 -right-2 rounded-full bg-red-500 text-white text-[10px] w-5 h-5 flex items-center justify-center">
                      {cartItems.length}
                    </span>
                  )}
                </span>
                <span className="text-[10px] sm:text-xs mt-1">Cart</span>
              </Link>

              {/* Hamburger (mobile) */}
              <button
                className="md:hidden text-2xl focus:outline-none hover:text-pink-700 transition"
                onClick={() => setIsMenuOpen((v) => !v)}
                aria-expanded={isMenuOpen}
                aria-label="Toggle navigation menu"
              >
                <i
                  className={`fa-solid ${isMenuOpen ? "fa-xmark" : "fa-bars"}`}
                />
              </button>
            </div>
          </div>

          {/* Mobile search (only once, clean placement) */}
          <div className="md:hidden mt-3">
            <form onSubmit={handleSearch} className="flex w-full">
              <input
                type="text"
                placeholder="Search products..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full px-4 py-2 rounded-l-md bg-pink-100 text-mainpink placeholder-pink-400 focus:outline-none focus:ring-2 focus:ring-pink-300 transition"
                aria-label="Search products"
              />
              <button
                type="submit"
                className="px-4 py-2 bg-mainpink text-white rounded-r-md hover:bg-pink-700 transition"
                aria-label="Submit search"
              >
                <i className="fa-solid fa-magnifying-glass" />
              </button>
            </form>
          </div>
        </div>

        {/* Category Navbar */}
        <div className={`${isMenuOpen ? "block" : "hidden"} md:block`}>
          <CategoryNavbar closeMenu={() => setIsMenuOpen(false)} />
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
